// Switches for the Firestore -> PocketBase move. See docs/pocketbase-migration-plan.md §5.
// Rolling back any step is: change the value here, build, deploy. No data moves.

// Release A: also upload finished games, campaigns and usernames to PocketBase, and keep a
// game in the device's upload queue until PocketBase has all of it. Turn on only after
// Steps 1–2 (routes deployed, backfill verified); until then leave false.
export const PB_WRITE = true;

// Release B: where the Stats tab, shared game links and campaign lists read from.
// 'firestore' until Step 4. A ?statsSource=pb or ?statsSource=firestore URL parameter
// overrides this for one page load, to compare the two side by side.
const STATS_SOURCE = 'pb'; //'firestore';

export function statsSource(){
    try{
        let s = new URLSearchParams(window.location.search).get('statsSource');
        if(s == 'pb' || s == 'firestore') return s;
    }catch(e){
        // no window (tests)
    }
    return STATS_SOURCE;
}
